export default __webpack_public_path__ + "static/media/p2p-hover.54e4fc66.webp";